import React from 'react'
import { connect } from 'react-redux'
import { userAgent } from '../utils'
import { useScrollIsLock } from '../slices/ui'

const backgroundFixedPosition = userAgent.os.name == 'ios' && userAgent.os.majorVersion < 13

class Main extends React.PureComponent {
  constructor (props) {
    super(props)
    this._lastScrollTop = null
  }

  componentDidMount () {
    this.updateDoucument(false, {})
  }

  componentWillUnmount () {
    this._lastScrollTop = 0
    window.document.documentElement.style.cssText = ''
  }

  getSnapshotBeforeUpdate (prevProps, prevState) {
    const snapshot = {}
    if (this.props.isLock) {
      snapshot.scrollBarWidth = window.innerWidth - window.document.documentElement.clientWidth
      if (backgroundFixedPosition) {
        snapshot.lastScrollTop = window.pageYOffset
      }
    }
    return snapshot
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.updateDoucument(prevProps.isLock, snapshot)
  }

  render () {
    return (
      <main id="content" aria-hidden={(this.props.isLock) ? 'true' : 'false'} className={ this.props.className }>
        {this.props.children}
      </main>
    )
  }

  updateDoucument (isLock, snapshot) {
    if (this.props.isLock != isLock) {
      if (this.props.isLock) {
        let style
        if (backgroundFixedPosition) {
          style = `overflow-y:hidden;position:fixed;width:100%;top:-${snapshot.lastScrollTop || 0}px;`
          this._lastScrollTop = snapshot.lastScrollTop
        } else {
          style = 'overflow-y:hidden;'
        }
        if (snapshot.scrollBarWidth > 0) {
          window.document.documentElement.style.cssText = `${style}--lock-scroll-padding:${snapshot.scrollBarWidth}px;`
        } else {
          window.document.documentElement.style.cssText = style
        }
        this._lastScrollTop = snapshot.lastScrollTop
      } else {
        window.document.documentElement.style.cssText = ''
        if (backgroundFixedPosition && this._lastScrollTop) {
          window.scrollTo(0, this._lastScrollTop)
          this._lastScrollTop = null
        }
      }
    }
  }
}

const ConnectedMain = (props) => {
  const isLock = useScrollIsLock()
  return <Main isLock={isLock} className={props.className}>{props.children}</Main>
}

export default ConnectedMain
